/**
 * Which of OgreClan's addresses this page is on (the same app runs on all three), and the others':
 * ogreclan.com (the home site: guides, metagames, blog), chat.ogreclan.com (OgreClan AI), and draft.ogreclan.com.
 * Developing, home.localhost and chat.localhost are the home site and the chat site.
 */
const host = location.hostname;
const port = location.port ? `:${location.port}` : '';
const base = host.replace(/^(www|home|chat|draft)\./, '');

export const HOME_HOST = host === 'ogreclan.com' || host === 'www.ogreclan.com' || host.startsWith('home.');
export const CHAT_HOST = host.startsWith('chat.');
/** On ogreclan.com itself (not developing): the draft site sends its guides there */
export const LIVE = base === 'ogreclan.com';

export const DRAFT_ORIGIN = `${location.protocol}//draft.${base}${port}`;

/** OgreClan's Discord server, and its two Chrome extensions on the Chrome Web Store */
export const DISCORD_INVITE = 'https://discord.gg/sMuJVBHM6V';
export const TOOLKIT_STORE = 'https://chromewebstore.google.com/detail/ogre-clan-toolkit-for-pok/olamgdmeilnpadogidonnjoeedlbjeje';
export const THEME_STORE = 'https://chromewebstore.google.com/detail/ogreclan-theme/abgphafglpegghofanipjbcnoopmamfk';
export const HOME_ORIGIN = LIVE ? `${location.protocol}//ogreclan.com` : `${location.protocol}//home.${base}${port}`;

/** A draft site page's address from this site (relative on the draft site itself) */
export function draftUrl(path: string) {
	return HOME_HOST || CHAT_HOST ? `${DRAFT_ORIGIN}${path}` : path;
}
